<template>
  <div>
    <el-card >
      <div slot="header" class="flex justify-between">
        <div>{{ $t('gold.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="goldInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="goldInfo.conditions.communityName" :placeholder="$t('gold.communityNamePlaceholder')"
              clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="goldInfo.conditions.communityId" :placeholder="$t('gold.communityIdPlaceholder')"
              clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryGoldMethod()">
              <i class="el-icon-search"></i>
              {{ $t('gold.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('gold.communityGold') }}</div>
        <div class="ibox-tools" style="top:10px;">
          <el-button type="text" @click="vc.toDoc('/pages/mall/goods/buyGoodSendGold_mall.html')">
            {{ $t('gold.document') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-table :data="goldInfo.golds" border style="width: 100%"
          :default-sort="{ prop: 'goldId', order: 'ascending' }">
          <el-table-column prop="goldId" :label="$t('gold.goldAccount')" align="center"></el-table-column>
          <el-table-column prop="storeName" :label="$t('gold.propertyCompany')" align="center"></el-table-column>
          <el-table-column prop="communityName" :label="$t('gold.communityName')" align="center"></el-table-column>
          <el-table-column prop="communityId" :label="$t('gold.communityId')" align="center"></el-table-column>
          <el-table-column prop="amount" :label="$t('gold.balance')" align="center"></el-table-column>
          <el-table-column :label="$t('gold.operation')" align="center">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" @click="_openEditGoldModel(scope.row)">
                  {{ $t('gold.edit') }}
                </el-button>
                <el-button size="mini" @click="_openDeleteGoldModel(scope.row)">
                  {{ $t('gold.delete') }}
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="goldInfo.conditions.page"
          :page-size="goldInfo.conditions.row" layout="total, prev, pager, next, jumper"
          :total="goldInfo.total"></el-pagination>
      </div>
    </el-card>

    <edit-gold ref="editGold" @refresh="queryGold"></edit-gold>
    <delete-gold ref="deleteGold" @refresh="queryGold"></delete-gold>
  </div>
</template>

<script>
import { listGold } from '@/api/admin/gold/goldApi'
import EditGold from '@/components/admin/editGold/editGold'
import DeleteGold from '@/components/admin/deleteGold/deleteGold'

export default {
  name: 'Gold',
  components: {
    EditGold,
    DeleteGold
  },
  data() {
    return {
      goldInfo: {
        golds: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          page: 1,
          row: 10,
          communityName: '',
          communityId: ''
        }
      }
    }
  },
  created() {
    this._listGolds(1, 10)
  },
  methods: {
    handleCurrentChange(val) {
      this._listGolds(val, this.goldInfo.conditions.row)
    },
    queryGold() {
      this._listGolds(1, 10)
    },
    _listGolds(page, rows) {
      this.goldInfo.conditions.page = page
      this.goldInfo.conditions.row = rows
      listGold(this.goldInfo.conditions).then(res => {
        this.goldInfo.total = res.total
        this.goldInfo.records = res.records
        this.goldInfo.golds = res.data
      })
    },
    _openEditGoldModel(gold) {
      this.$refs.editGold.open(gold)
    },
    _openDeleteGoldModel(gold) {
      this.$refs.deleteGold.open(gold)
    },
    _queryGoldMethod() {
      this._listGolds(1, this.goldInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>